import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { getUserInited, getUserIsAuth } from '../../../../entities/User'
import { PageLoader } from '../../../../shared/ui/PageLoader/PageLoader'

interface RequireAuthProps {
    children: JSX.Element
    roles?: string[]
}

export function RequireAuth({ children }: RequireAuthProps) {
    const isAuth = useSelector(getUserIsAuth)
    const inited = useSelector(getUserInited)

    if (!inited) {
        return <PageLoader />
    }

    if (!isAuth) {
        return <Navigate to="/login" replace />
    }

    return children
}
